const UPDATE_SELECTED_VARIANT = 'UPDATE_SELECTED_VARIANT';

class BundlePicker extends HTMLElement{
    constructor(){
        super();
        const bundlePicker = this;
        const submitButton = document.querySelector("form.product-form button[type='submit']");

        this.addEventListener(UPDATE_SELECTED_VARIANT, (e) => {            
            //Count the number of Strongs selected, and 'click' the right variant selector
            let strongsSlected = bundlePicker.querySelectorAll("bundle-option[data-selected_product_handle='inertia-wave-strong']");
            bundlePicker.querySelector(`[data-product-option='STRONG Upgrades'] [data-value='${strongsSlected.length}']`).click();

            //Enable checkout if all options are selected
            if(bundlePicker.querySelector("bundle-option:not([data-selected_product_handle])") == null){
                submitButton.disabled = false;
            }           
        })        
        //Disable checkout until all options are selected
        submitButton.disabled = true;
    }
}
class BundleOption extends HTMLElement{
    constructor(){
        super();
        this.productSelector = this.querySelector("select[data-type='product']");
        this.variantSelectors = this.querySelectorAll("select[data-type='variant']");
        this.lineItem = this.querySelector(".bundle-option__line-item");
        let bundleOption = this;

        //Handle product selectors
        this.productSelector.addEventListener('change', function() {

            //Update selected product
            bundleOption.dataset.selected_product_handle = this.value;
            bundleOption.dataset.selected_product_title = this.options[this.selectedIndex].dataset.product_title;
        
            //Hide or show appropriate variant selectors
            bundleOption.variantSelectors.forEach((variantSelector) =>{
                if(variantSelector.dataset.for_product_handle == bundleOption.dataset.selected_product_handle){
                    variantSelector.dataset.active = true;
                    bundleOption.dataset.selected_variant = variantSelector.options[variantSelector.selectedIndex].value;
                }else{
                    variantSelector.dataset.active = false;
                }
            });

            //Update line item
            bundleOption.lineItem.value = `${bundleOption.dataset.selected_product_title} - ${bundleOption.dataset.selected_variant}`;

            //Update Shopify selected variant
            this.dispatchEvent(new CustomEvent(UPDATE_SELECTED_VARIANT, { bubbles: true }));
        });

        //Handle variant selectors
        this.variantSelectors.forEach((variantSelector) =>{
            variantSelector.addEventListener('change', function() {
                bundleOption.dataset.selected_variant = this.value;
                bundleOption.lineItem.value = `${bundleOption.dataset.selected_product_title} - ${bundleOption.dataset.selected_variant}`;
            });
        });
    }
}
customElements.define('bundle-picker', BundlePicker);
customElements.define('bundle-option', BundleOption);